import React from "react"
 import styled from "styled-components"
import PagesHero from "../shared/PagesHero"
import { useStaticQuery, graphql } from "gatsby"
import contactEmail from "../../assist/icons/contact/contactEmail.svg"
import contactPhone from "../../assist/icons/contact/contactPhone.svg"
import contactSocial from "../../assist/icons/contact/contactSocial.svg"
import Form from "./Form"
import Location from "../shared/Location"
const ContactPage = ({ lang }) => {
  const img = useStaticQuery(graphql`
    {
      strapiBanners(name: { eq: "contactBanner" }) {
        banner {
          childImageSharp {
            fluid(maxWidth: 1000, quality: 100) {
              ...GatsbyImageSharpFluid_tracedSVG
            }
          }
        }
      }
    }
  `)
  const words = {
    ar: {
      countactLink: "تواصل معنا",
      call: "اتصل بنا",
      callWellcom: "نسعد باللإجابة على إستفساراتكم",
      leaveMessage: "اترك لنا رسالة",
      willCall: "وسنتتواصل معك قريبا",
      location: "الموقع",
      happyToSee: "نسعد بزيارتكم",
      sendButton: "ارسل شكوى",
      sendButtonMess: "ارسل الرسالة",
      sendText: "نص الشكوى",
      sendTextMess: "نص الرسالة",
    },
    en: {
      countactLink: "Contact Us",
      call: "Call Us",
      callWellcom: "We are pleased to answer your inquiries",
      leaveMessage: "Leave a message",
      willCall: "We will contact you shortly",
      location: "Location",
      happyToSee: "We are pleased to your visit",
      sendButton: "Send complaint",
      sendButtonMess: "Send message",
      sendText: "Your complaint",
      sendTextMess: "Your message",
    },
    tr: {
      countactLink: "Bizimle iletişime geç",
      call: "Bizimle iletişime geçin",
      callWellcom: "Sorularınızı  yanıtlamaktan mutluluk duyarız",
      leaveMessage: "Bize mesaj bırak",
      willCall: "En yakın zamanda sizinle iletişime geçeceğiz",
      location: "konum",
      happyToSee: "Bizi ziyaret edin",
      sendButton: "Şikayet gönder",
      sendButtonMess: "mesaj gönder",
      sendText: "Şikayetin metni",
      sendTextMess: "Mesajın metni",
    },
  }
  const {
    countactLink,
    call,
    callWellcom,
    leaveMessage,
    willCall,
    location,
    happyToSee,
    sendButton,
    sendButtonMess,
    sendText,
    sendTextMess,
  } = words[lang]
  return (
    <Wraper>
      <PagesHero
        image={img.strapiBanners.banner.childImageSharp.fluid}
        activeLink={countactLink}
        className="divider"
        lang={lang}
      />

      <div className="container">
        <h2>{call} </h2>
        <p>{callWellcom}</p>

        <div className="contactInfo">
          <div className="phoneInfo">
            <img src={contactSocial} alt="social media" />
            <p>facebook.com/alresala.sy</p>
            <p>twitter.com/alresalango</p>
          </div>
          <div>
            <img src={contactEmail} alt="email" />
            <p>
              <a className="link" href="mailto:info@alresala.net">
                info@alresala.net
              </a>
            </p>
            <p>
              <a className="link" href="mailto:mazenibrahim@alresala.net">
                mazenibrahim@alresala.net
              </a>
            </p>
            <p>
              <a className="link" href="mailto:feedback@alresala.net">
                feedback@alresala.net
              </a>
            </p>
          </div>
          <div>
            <img src={contactPhone} alt="phone" />
            <p>
              <a className="link" href="tel:  +90 535 274 32 58">
                +90 535 274 32 58
              </a>
            </p>
            <p>
              <a className="link" href="tel:   +90 553 158 93 98">
                {" "}
                +90 553 158 93 98
              </a>
            </p>
            <p>
              <a className="link" href="tel:   +90 553 169 26 30">
                {" "}
                +90 553 169 26 30
              </a>
            </p>
          </div>
        </div>

        <div className="leaveMessage">
          <h2>{leaveMessage}</h2>
          <p>ً {willCall}</p>
          <div className="forms">
            <Form text={sendText} buttonText={sendButton} lang={lang} />
            <Form text={sendTextMess} buttonText={sendButtonMess} lang={lang} />
          </div>
        </div>
        <div className="location">
          <h2> {location}</h2>
          <span>{happyToSee}</span>
          <p className="textLocation">
            google.com/maps/@36.7169759,37.1015857,21z
          </p>
          <Location width="100%" height="400px" className="map" />
        </div>
      </div>
    </Wraper>
  )
}

export default ContactPage

const Wraper = styled.section`
  .divider {
    padding-top: 120px;
  }
  .container {
    text-align: center;
    padding-top: 50px;
    h2 {
      color: ${props => props.theme.dg};
    }
    span,
    p,
    .link {
      font-size: 1.3rem;
      color: ${props => props.theme.g2};
      margin: 0;
    }
    img {
      width: 120px;
    }
    .contactInfo {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr;
      padding: 50px 0 100px 0;
    }
    .leaveMessage {
      .forms {
        padding: 70px 0 100px 0;
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 60px;
      }
    }
  }
  .location {
    span {
      margin-left: 15px;
    }
    .map {
      margin: 50px 0;
    }
  }
  @media (max-width: 800px) {
    .container {
      .contactInfo {
        .phoneInfo {
          margin-bottom: 50px;
          grid-column-start: 1;
          grid-column-end: 3;
        }
        grid-template-columns: 1fr 1fr;
      }
    }
  }
  @media (max-width: 600px) {
    .forms {
      grid-template-columns: 1fr !important;
    }

    .divider {
      padding-top: 20px;
    }
  }
  @media (max-width: 530px) {
    .container {
      .contactInfo {
        grid-template-columns: 1fr;
        gap: 50px;

        .phoneInfo {
          grid-column-start: 1;
          grid-column-end: 1;
          margin-bottom: 0;
        }
      }
    }
  }
  @media (max-width: 480px) {
    .textLocation,
    p,
    a,
    span {
      font-size: 0.8rem !important;
    }
    h2 {
      font-size: 1.2rem !important;
    }
    img {
      width: 80px !important;
    }
    .contactInfo {
      padding: 20px 0 20px 0 !important;
    }

    .forms {
      padding: 40px 0 25px 0 !important;
    }
  }
`
